/**
 * Emit hosts for the `compliance` analytics group — 3 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  ComplianceSource,
  ComplianceStatus,
  type NHSAskHeidiComplianceDetailedProps,
  type NHSTemplateComplianceDetailedProps,
} from '@/models/analytics/features/compliance';

export function trackAskHeidiComplianceBlock(props?: NHSAskHeidiComplianceDetailedProps) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ComplianceCheck,
    props: {
      source: ComplianceSource.NHSAskHeidi,
      status: ComplianceStatus.Blocked,
      ...props,
    },
  });
}

export function trackNhsTemplateComplianceBlock(
  props?: NHSTemplateComplianceDetailedProps
) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ComplianceCheck,
    props: {
      source: ComplianceSource.NHSTemplate,
      status: ComplianceStatus.Blocked,
      ...props,
    },
  });
}

export function trackNhsTemplateComplianceWarning(
  props?: NHSTemplateComplianceDetailedProps
) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ComplianceCheck,
    props: {
      source: ComplianceSource.NHSTemplate,
      status: ComplianceStatus.Warning,
      ...props,
    },
  });
}
